import React from 'react'
import Todo from './components/Todo';

const App = () => {
  return (
    <>
      <Todo></Todo>
    </>
  )
}

export default App
